import { Price } from "./Price";
import { Stock } from "./Stock";

export class Product {

  public id: number;
  public name: string;
  public compl_name?: string;
  public ean: string;
  public description: string;
  public code_product: string;
  public image_url?: string;
  public img_url_min?: string;
  public last_date_update: Date;
  public universe_id: number;
  public sub_universe_id: number;
  public created_at: Date;
  public updated_at: Date;
  public stock?:Stock[];
  public price?:Price;
  public is_disabled: boolean;
  public multiplier: number;
  public details: {label: string, value: string}[];
  public pim_sync_at: Date;
  public source: string | null;
  public is_platform: boolean; // RAG-50 : produit importé de la Plateforme Socoda
  public provider: string | null;
  public brand?: { id: string; name: string } | null;
  public pim_source_rule?: string | null; // RAG-38 : règle PIM effective (fiche)
  public category?: { id: string; name: string } | null; // Test 4 : catégorie courante
  public category_manual?: boolean; // Test 4 : catégorie fixée à la main (protégée de la synchro)

  constructor(data: any){
    this.id = data.id;
    this.name = data.name;
    this.source = data.source ?? null;
    this.is_platform = data.is_platform == true ? true : false;
    this.provider = data.provider ?? null;
    this.brand = data.brand ?? null;
    this.pim_source_rule = data.pim_source_rule ?? null;
    this.category = data.category ?? null;
    this.category_manual = data.category_manual === true;
    this.compl_name = data.compl_name;
    this.ean = data.ean;
    this.description = data.description;
    this.code_product = data.code_product;
    // L'API renvoie le visuel sous `img_url` (jamais `image_url`) : on l'aligne
    // ici pour que la vignette de la fiche produit s'affiche (fiche + vue liste).
    this.image_url = data.image_url ?? data.img_url ?? data.img_url_min;
    this.img_url_min = data.img_url_min;
    this.last_date_update = new Date(data.last_date_update);
    this.universe_id = data.universe_id;
    this.sub_universe_id = data.sub_universe_id;
    this.created_at = new Date(data.created_at);
    this.updated_at = new Date(data.updated_at);
    this.is_disabled = data.is_disabled == true ? true : false;
    this.stock = data.stock;
    this.price = data.price;
    this.multiplier = data.multiplier;
    this.details = data.details;
    
    if(data.price){
      this.price = new Price(data.price)
    }
    if(data.stock){
        this.stock = data.stock.map((stock:any) => new Stock(stock))
    }
    this.pim_sync_at = new Date(data.pim_sync_at)
  }

  totalStock(){
    if (this.stock) {
      const sum = this.stock.reduce((accumulator, value) => {
        return accumulator + value.stock;
      }, 0);
      return sum
    }
    return
  }
}
